// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_ESHOPS = ["%(counter)s e-shop", "%(counter)s e-shopy", "%(counter)s e-shop\u016f"];
export const counter_VARIANTS = ["%(counter)s varianta", "%(counter)s varianty", "%(counter)s variant"];
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00e1rkopedie";
